<template>
  <section :id="data?.anchor_id ? data.anchor_id : null" class="destination container defaultSectionMargins">
    <h2 v-html="data.title" />

    <FlarePicture
      v-for="item in [data.left_image, data.right_image]"
      class="destination__DesktopImage"
      :src="{
        1920: { src: item, width: 900, height: 675, size: 'both', crop: 'fill' },
      }"
      :alt="item.alt"
    />

    <FlickitySlider class="destination__Slider" :options="flickityOptions">
      <Flare v-for="image in [data.left_image, data.right_image]" :srcset="image" size="both" width="644" height="480" crop="fill" :alt="image" />
    </FlickitySlider>

    <div class="destination__Infos">
      <p v-if="data.lead" v-text="data.lead" />
      <Button v-if="data.page.sef" type="nuxt-link" :to="data.page.sef" secondary medium>
        {{ data.cta_text }}
      </Button>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  });

  const flickityOptions = {
    pageDots: false,
    prevNextButtons: false,
    contain: true,
  };
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_destination.scss');
</style>